import { useEffect, useState } from 'react';

import { useAuthStore } from '../store';

/** Hook to determine if the org is UES */
export function useUESCheck() {
  const {
    authValues: {
      organisationState: { organisation },
    },
  } = useAuthStore();
  const [isUES, setUES] = useState(false);

  useEffect(() => {
    if (organisation?.ues) setUES(true);
  }, [organisation?.ues]);

  return isUES;
}
